import { useCallback, useEffect, useRef } from 'react';
import { useIsVisible } from '../../utils/useIsVisibleHook';

type VideoComponentProps = {
  src: string;
  alt?: string;
};
export const VideoComponent = ({ src, alt }: VideoComponentProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { isVisible, targetRef } = useIsVisible(
    {
      root: null,
      rootMargin: '200px',
      threshold: 0.1
    },
    false
  );
  const startVideoOnMouseMove = useCallback(async () => {
    try {
      videoRef.current.src = src;
      await videoRef.current.play();
    } catch (e) {
      // do nothing
      console.log('Error occured while loading the video!');
    }
  }, []);

  useEffect(() => {
    if (isVisible) {
      startVideoOnMouseMove();
    }
  }, [isVisible, startVideoOnMouseMove]);

  return (
    <span ref={targetRef as never}>
      <video ref={videoRef} loop muted autoPlay playsInline aria-label={alt}>
        Your browser does not support the video tag. Please try viewing this page in a modern browser.
      </video>
    </span>
  );
};
